import { FC } from "react";
import { MapSidebar } from "@landtechnologies/components";
import type { SiteFeature } from "src/js/stores/siteGeometry/store";
import { Link } from "react-migration/components/Link";
import { EditableSiteDetails } from "react-migration/domains/sites/components/SiteCard/EditableSiteDetails";

interface SiteCardProps {
  site: SiteFeature;
  backText?: string;
  onClose: () => void;
  onBack?: () => void;
}

export const SiteCard: FC<SiteCardProps> = ({ site, backText, onClose, onBack }) => {
  return (
    <MapSidebar>
      <MapSidebar.Header>
        <MapSidebar.HeaderTitle>
          <MapSidebar.HeaderName>
            <Link
              className="atlas-text-white hover:atlas-text-white hover:atlas-underline"
              to={{ name: "sites", query: { site_id: site.id } }}
            >
              {site.properties.title}
            </Link>
          </MapSidebar.HeaderName>
          <MapSidebar.Close onClose={onClose} />
        </MapSidebar.HeaderTitle>
      </MapSidebar.Header>
      <MapSidebar.Body>
        <div className="atlas-flex atlas-flex-col atlas-gap-y-3">
          {!!(backText && onBack) && (
            <MapSidebar.BodyAction title={backText} action={onBack}>
              <i className="icon-lt-arrow-left-s-line atlas-fill-content-link atlas-shrink-0" />
              {backText}
            </MapSidebar.BodyAction>
          )}
          <EditableSiteDetails siteId={site.id} onDelete={onBack ? onBack : onClose} />
        </div>
      </MapSidebar.Body>
    </MapSidebar>
  );
};
